import getPriceSheetTypeAbbreviation from "./getPriceSheetTypeAbbrevation";
import { formatSheetVersionDate } from "./formatSheetVersionDate";

export const generateSheetName = (
  siteInput: string,
  priceSheetType: string,
  customerNameInput: string,
  priceSheetStartDate: Date,
  priceSheetEndDate: Date,
) => {
  const site =
    siteInput && priceSheetType === "Projekti"
      ? `_${siteInput?.replace(/\s/g, "")}`
      : "";
  const customerName = customerNameInput?.replace(/\s/g, "");
  return `${customerName}${site}_${formatSheetVersionDate(priceSheetStartDate)}-${formatSheetVersionDate(priceSheetEndDate)}_${getPriceSheetTypeAbbreviation(priceSheetType)}`;
};
